import { FiCheck, FiX } from 'react-icons/fi';
import { usePreferences } from '../../../contexts/PreferencesContext';
import { PASSWORD_REQUIREMENTS, getPasswordStrengthLevel } from '../../../utils/validation';
import styles from './PasswordStrengthMeter.module.css';

interface PasswordStrengthMeterProps {
    password: string;
}

export function PasswordStrengthMeter({ password }: PasswordStrengthMeterProps) {
    const { t } = usePreferences();
    const metCount = PASSWORD_REQUIREMENTS.filter((req) => req.test(password)).length;
    const level = getPasswordStrengthLevel(password);

    return (
        <div className={styles.wrapper}>
            <div className={styles.bar}>
                {PASSWORD_REQUIREMENTS.map((_, index) => (
                    <span
                        key={index}
                        className={`${styles.segment} ${index < metCount ? styles[level] : ''}`}
                    />
                ))}
            </div>

            <ul className={styles.list}>
                {PASSWORD_REQUIREMENTS.map((req) => {
                    const met = req.test(password);
                    return (
                        <li key={req.id} className={met ? styles.itemMet : styles.itemUnmet}>
                            <span className={styles.icon}>
                                {met ? <FiCheck size={11} /> : <FiX size={11} />}
                            </span>
                            {t(req.labelKey)}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}